import { Hero } from '@/components/Hero';
import { ServicesGrid } from '@/components/ServicesGrid';
import { CaseStudyStrip } from '@/components/CaseStudyStrip';
import { TestimonialQueue } from '@/components/TestimonialQueue';
import { CleicWaitlist } from '@/components/CleicWaitlist';
import { ContactForm } from '@/components/ContactForm';

export default function Home() {
  return (
    <>
      <Hero />
      <ServicesGrid />
      <CaseStudyStrip />
      <TestimonialQueue />
      <CleicWaitlist />
      <ContactForm />
    </>
  );
}
